<template>
    <a-drawer :title="titleName" width="1000px" placement="right" :closable="true" :visible="visible" @close="handleCancelEvent">
        <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol" class="mt20" ref="formRef">
            <a-form-item :label="$t('submission.email_template.title' /*标题*/)">
                <a-input v-decorator="['title']" :placeholder="$t('submission.email_template.enter_title' /*请输入标题*/)" />
            </a-form-item>
            <a-form-item :label="$t('submission.email_template.sender_name' /*发件人名称*/)">
                <a-input v-decorator="['send_name']" :placeholder="$t('submission.email_template.enter_sender_name' /*请输入发件人名称*/)" />
            </a-form-item>
            <a-form-item :label="$t('submission.email_template.email_address' /*发送/接收邮箱*/)">
                <a-input v-decorator="['receive_email']" :placeholder="$t('submission.email_template.enter_email_address' /*请输入发送/接收邮箱*/)" />
            </a-form-item>
            <a-form-item :label="$t('submission.email_template.email_subject' /*邮箱主题*/)">
                <a-input v-decorator="['theme']" :placeholder="$t('submission.email_template.enter_email_subject' /*请输入邮箱主题*/)" />
            </a-form-item>
            <a-form-item :label="$t('submission.email_template.template_content' /*模板内容*/)">
                <tinymce-editor v-decorator="['content']" ref="tinymceRef"></tinymce-editor>
            </a-form-item>
            <a-form-item :label="$t('submission.email_template.is_enabled' /*是否启用*/)">
                <a-radio-group v-decorator="['status', { initialValue: '1' }]">
                    <a-radio value="1">{{ $t('submission.email_template.yes' /*是*/) }}</a-radio>
                    <a-radio value="0">{{ $t('submission.email_template.no' /*否*/) }}</a-radio>
                </a-radio-group>
            </a-form-item>
        </a-form>

        <a-collapse style="margin-bottom: 50px">
            <a-collapse-panel v-for="(item, index) in tagsObj" :key="index" :header="index" :forceRender="true">
                <a-row :gutter="[15, 15]">
                    <a-col :span="12" v-for="(it, ind) in item" :key="ind" @click="handleAddtagsEvent(it)">
                        <a-button type="link">{{ ind }}</a-button>
                    </a-col>
                </a-row>
            </a-collapse-panel>
        </a-collapse>

        <div
            class="t-r"
            :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                height: '50px',
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 1
            }"
        >
            <a-button type="default" @click="handleCancelEvent">{{ $t('submission.email_template.close' /*关闭*/) }}</a-button>
            <a-button class="ml10" type="primary" @click="handleSubmitEvent">{{ $t('submission.email_template.submit' /*提交*/) }}</a-button>
        </div>
    </a-drawer>
</template>

<script>
const fields = ['id', 'title', 'send_name', 'receive_email', 'theme', 'content', 'status'];
import tinymceEditor from '@/components/Tinymce/index.vue';
import pick from 'lodash.pick';
export default {
    name: 'EditEmail',
    components: { tinymceEditor },
    data() {
        return {
            visible: false,
            labelCol: {
                xs: { span: 24 },
                sm: { span: this.$route.params.lang == 'cn' ? 4 : 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: this.$route.params.lang == 'cn' ? 20 : 18 }
            },
            form: this.$form.createForm(this),
            tagsObj: {},
            language: 1,
            template_id: '',
            titleName: ''
        };
    },
    computed: {},
    methods: {
        show(template_type, language, titleName) {
            this.titleName = titleName;
            this.visible = true;
            // 防止表单未注册
            fields.forEach(v => {
                this.form.getFieldDecorator(v);
            });
            let data = {
                type: 2, // 1短信 2邮件
                template_type, // 设置录取通知函邮件（中英文模版类型值 8），设置审核通过类型值邮件：19），设置审核驳回模版类型值：邮件：20
                language
            };
            this.language = language;
            this.getAbstractTemplateInfo(data);
            this.getAbstractTemplateTags();
        },
        handleCancelEvent() {
            this.visible = false;
        },
        handleSubmitEvent() {
            this.form.validateFields((error, values) => {
                let data = {
                    type: 2,
                    language: this.language,
                    template_id: this.template_id,
                    ...values
                };
                this.$request.post({ url: 'setAbstractTemplate', data: data }).then(res => {
                    this.$message.success(this.$t('submission.email_template.submit_success' /*提交成功*/));
                });
            });
        },
        // 插入标签
        handleAddtagsEvent(item) {
            this.$refs.tinymceRef.insertContent(item);
        },
        getAbstractTemplateTags() {
            this.$request.get({ url: 'getAbstractTemplateTags', data: { type: 2 } }).then(res => {
                const { data } = res;
                this.tagsObj = data;
            });
        },
        getAbstractTemplateInfo(data) {
            this.$request.get({ url: 'getAbstractTemplateInfo', data }).then(res => {
                const { data } = res;
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(data, fields));
                    this.template_id = data.id;
                });
            });
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="less" scoped>
.preview-box {
    padding: 30px;
    background-color: #f9f9f9;
}
</style>
